











import Vue from 'vue'
import { Component } from 'vue-property-decorator'

/**
 * Material Icons の shopping_bag(Apache License 2.0)を inline SVG にしたもの。
 * 本アプリはアイコンフォントを読み込んでいないため、フォント追加ではなくパスを直接埋め込む。
 */
@Component
export default class ShoppingBagIcon extends Vue {}
